import React from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Typography,
  FormHelperText,
} from '@material-ui/core';
import ReactInputMask from 'react-input-mask';
import { Autocomplete as AutoComplete } from '@material-ui/lab';
import Autocomplete, {
  createFilterOptions,
} from '@material-ui/lab/Autocomplete';
import DateFnsUtils from '@date-io/date-fns';
import { BENEFICIARY } from 'containers/data-structure';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import { get, isEmpty, uniqueId, isNil } from 'lodash';
import moment from 'moment-timezone';
import styled from 'styled-components';
import frLocale from 'date-fns/locale/fr';
import { arrayTranslate, translate } from 'containers/services/translate';
import SahamAccordion from 'components/SahamAccordion';
import { Listings, SagisConfig } from 'containers/AppContainer/typings';
import { VICTIM } from 'containers/data-structure';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { displayErrorText } from 'containers/services/validateForm';
import {
  checkClassVictim,
  checkUniqCinVictim,
  isMinorVictim,
  checkVictimAge,
} from 'containers/PreOpeningPage/utils';
import {
  GENDER,
  INJURY_POST,
  MINOR_VALUE,
} from 'containers/PreOpeningPage/constants';
import BeneficiaryAccordion from 'containers/PreOpeningPage/BeneficiaryAccordion';
import { filterVisibleOnly } from 'containers/services/filters';
import { getMoroccanCities, getCity } from 'containers/RecapManagerPage/utils';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import { Beneficiary } from 'containers/PreOpeningPage/typings';
import messages from 'containers/PreOpeningPage/messages';
import { getDateIgnoreTimezone } from 'containers/common/LegalProceedings/utils';
import { DATE_FORMAT } from 'constants/global';
import { isOtherProfession } from 'containers/CourtManagerLegalProceedings/utils';
import { OTHER_PROFESSION } from 'containers/RecapManagerPage/constants';
import { VICTIM_ITT_AVAILABILITY } from 'containers/PreOpeningPage/constants';
import { VICTIM_QUALITY_KEYS } from 'containers/CourtManagerLegalProceedings/constants';
import { displayVehiclePassenger } from 'services/utils';
import { BeneficiaryType, VictimType } from 'typings/globalTypes';
import { ClaimRecapType } from 'typings/claimTypes';

const ContentWrapper = styled(Grid)`
  margin-bottom: 16px;
`;
export interface VictimFormProps {
  intl: IntlShape;
  inputProps?: any;
  disableInput?: boolean;
  inputLabelProps?: boolean;
  listings: Listings;
  nbr: number;
  formValues: VictimType;
  setFormValues: Function;
  victimValidation: any;
  claimRecap: ClaimRecapType;
  isDrawerAdd?: boolean;
}

const StyledSelect = styled(Select)`
  &.MuiInput-underline.Mui-disabled:before {
    border-bottom-style: solid;
  }
  .MuiSelect-icon {
    color: black;
  }
  font-weight: 500;
`;

const VictimFormComponent: React.FC<VictimFormProps> = props => {
  const { nbr, formValues, setFormValues } = props;

  const [expanded, setExpanded] = React.useState(true);
  const [openBeneficiaryForm, setOpenBeneficiaryForm] = React.useState(false);

  const handleChangeExpanded = (
    event: React.ChangeEvent<{}>,
    expanded: boolean,
  ) => {
    setExpanded(expanded);
  };

  const inputLabel = React.useRef<HTMLLabelElement>(null);

  const handleDateChange = (fieldName: string) => (date: Date | null) => {
    const theDate = getDateIgnoreTimezone(date);
    setFormValues(Object.assign({}, formValues, { [fieldName]: theDate }));
  };

  const handleChange = (fieldName: string) => (
    event: React.ChangeEvent<{
      name?: string;
      value?: any;
    }>,
    valueField?: any,
  ) => {
    if (fieldName === VICTIM.ITT) {
      setFormValues(
        Object.assign({}, formValues, {
          [fieldName]: event.target.value.replace(/[^0-9]/g, ''),
        }),
      );
    }
    if (fieldName === VICTIM.TELEPHONE_NUMBER) {
      return setFormValues(
        Object.assign({}, formValues, {
          [fieldName]: event.target.value.replace(/\s+/g, ''),
        }),
      );
    }
    if (fieldName === VICTIM.PROFESSION_TYPE) {
      return setFormValues(
        Object.assign({}, formValues, {
          [fieldName]: get(valueField, 'ItemKey'),
          [VICTIM.PROFESSION]:
            get(valueField, 'ItemKey') === OTHER_PROFESSION
              ? get(formValues, VICTIM.PROFESSION)
              : null,
        }),
      );
    }
    if (
      fieldName === VICTIM.CLASS_KEY &&
      get(formValues, [VICTIM.CLASS_KEY]) === MINOR_VALUE
    ) {
      setFormValues(
        Object.assign({}, formValues, {
          [fieldName]: event.target.value,
          [VICTIM.NUMBER_OF_SPOUSE]: 0,
          [VICTIM.NUMBER_OF_DEPENDENTS]: 0,
          [VICTIM.NUMBER_OF_CHILDREN]: 0,
        }),
      );
    }
    if (
      fieldName === VICTIM.QUALITY_KEY &&
      featureService.hasFeature(FEATURES.IS_VICTIM_EXCLUDED_FROM_COVERAGE)
    ) {
      const isExludedVictim: boolean =
        event.target.value === VICTIM_QUALITY_KEYS.Driver ||
        event.target.value === VICTIM_QUALITY_KEYS.Subscriber;

      return setFormValues(
        Object.assign(
          {},
          { ...formValues, isExcluded: isExludedVictim },
          {
            [fieldName]: event.target.value,
          },
        ),
      );
    } else {
      setFormValues(
        Object.assign({}, formValues, { [fieldName]: event.target.value }),
      );
    }
  };

  const openFormBeneficiary = () => {
    setOpenBeneficiaryForm(true);
  };

  const closeFormBeneficiary = () => {
    setOpenBeneficiaryForm(false);
  };
  const handleCityChange = (fieldName: string) => (
    event: React.ChangeEvent<{
      name?: string;
      value?: any;
    }>,
    newValue: SagisConfig | null,
  ) => {
    setFormValues(
      Object.assign({}, formValues, { [fieldName]: newValue?.ItemKey }),
    );
  };
  const saveBeneficiary = (beneficiary: Beneficiary) => {
    formValues[VICTIM.BENEFICIARIES].push(beneficiary as never);
    closeFormBeneficiary();
    setFormValues(Object.assign({}, { ...formValues }));
  };

  const handleBeneficiaryChange = (beneficiary_index: number) => (
    beneficiary: Beneficiary,
  ) => {
    //@ts-ignore
    formValues[VICTIM.BENEFICIARIES][beneficiary_index] = beneficiary;
    setFormValues(Object.assign({}, { ...formValues }));
  };

  const filterOptions = createFilterOptions({
    matchFrom: 'start',
    stringify: (option: SagisConfig) => option?.ItemDescription,
  });
  const translateArrayErrorMessages = arrayTranslate(props.intl.formatMessage);
  const { message } = displayErrorText(
    props.victimValidation,
    translateArrayErrorMessages(props.victimValidation, true),
  );
  return (
    <SahamAccordion
      expanded={expanded}
      onChange={handleChangeExpanded}
      title={translate({ ...messages.victimAccordionTitle }, props, {
        number: nbr,
      })}
    >
      <ContentWrapper container spacing={2}>
        <Grid container item spacing={2}>
          <Grid item xs={12}>
            <FormControl
              fullWidth
              error={!!get(props.victimValidation, [VICTIM.INJURY_POST_KEY])}
            >
              <InputLabel
                ref={inputLabel}
                id="simple-select-outlined-label-procedure"
                shrink={props.inputLabelProps}
              >
                {translate({ ...messages.victimInjuryPostKey }, props)}
              </InputLabel>
              <Select
                fullWidth
                name={VICTIM.INJURY_POST_KEY}
                value={
                  formValues.injuryPostKey === INJURY_POST.INJURED[1]
                    ? INJURY_POST.INJURED[0]
                    : formValues.injuryPostKey
                }
                onChange={handleChange(VICTIM.INJURY_POST_KEY)}
                disabled={props.disableInput}
                labelWidth={230}
              >
                {!isEmpty(get(props.listings, 'prejudice', [])) &&
                  props
                    .listings!.prejudice.filter(
                      (el: any) => el.ItemKey !== INJURY_POST.INJURED[1],
                    )
                    .map(e => (
                      <MenuItem value={e.ItemKey} key={e.ItemKey}>
                        {get(e.ItemDescription.split(' '), '[0]', '')}
                      </MenuItem>
                    ))}
              </Select>
              {!!get(props.victimValidation, [VICTIM.INJURY_POST_KEY]) && (
                <FormHelperText className="errorSelect">
                  {message[VICTIM.INJURY_POST_KEY]}
                </FormHelperText>
              )}
            </FormControl>
          </Grid>
        </Grid>
        <Grid container item spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label={translate({ ...messages.victimCin }, props)}
              name={VICTIM.CIN}
              value={formValues.cin}
              onChange={handleChange(VICTIM.CIN)}
              InputProps={props.inputProps}
              error={
                !!get(props.victimValidation, [VICTIM.CIN]) ||
                (checkUniqCinVictim(
                  [...get(props.claimRecap, 'victims', [])],
                  get(formValues, [VICTIM.CIN]),
                  nbr as any,
                  get(props.claimRecap, 'claim.lossDate'),
                ) &&
                  !isMinorVictim(
                    formValues,
                    moment(get(props.claimRecap, 'claim.lossDate')).format(
                      'YYYY-MM-DD',
                    ),
                  ))
              }
              helperText={
                checkUniqCinVictim(
                  [...get(props.claimRecap, 'victims', [])],
                  get(formValues, [VICTIM.CIN]),
                  nbr as any,
                  get(props.claimRecap, 'claim.lossDate'),
                ) &&
                !isMinorVictim(
                  formValues,
                  moment(get(props.claimRecap, 'claim.lossDate')).format(
                    'YYYY-MM-DD',
                  ),
                )
                  ? translate(messages.errorCinVictim, props)
                  : message[VICTIM.CIN]
              }
              disabled={props.disableInput}
              InputLabelProps={{ shrink: props.inputLabelProps }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label={translate({ ...messages.victimLastName }, props)}
              name={VICTIM.LAST_NAME}
              value={formValues.lastName}
              onChange={handleChange(VICTIM.LAST_NAME)}
              error={!!get(props.victimValidation, [VICTIM.LAST_NAME])}
              InputProps={props.inputProps}
              disabled={props.disableInput}
              InputLabelProps={{ shrink: props.inputLabelProps }}
              helperText={message[VICTIM.LAST_NAME]}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label={translate({ ...messages.victimFirstName }, props)}
              InputProps={props.inputProps}
              name={VICTIM.FIRST_NAME}
              value={formValues.firstName}
              onChange={handleChange(VICTIM.FIRST_NAME)}
              error={!!get(props.victimValidation, [VICTIM.FIRST_NAME])}
              disabled={props.disableInput}
              InputLabelProps={{ shrink: props.inputLabelProps }}
              helperText={message[VICTIM.FIRST_NAME]}
            />
          </Grid>
          <Grid item xs={12}>
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
              <KeyboardDatePicker
                fullWidth
                autoOk
                variant="inline"
                format="dd/MM/yyyy"
                id="date-picker-inline-victim-date-of-birth"
                label={translate({ ...messages.victimDateOfBirth }, props)}
                name={VICTIM.DATE_OF_BIRTH}
                value={formValues.dateOfBirth}
                error={
                  !!get(props.victimValidation, [VICTIM.DATE_OF_BIRTH]) ||
                  moment(formValues.dateOfBirth).format(DATE_FORMAT) ===
                    'Invalid date' ||
                  checkVictimAge(
                    formValues.dateOfBirth,
                    get(props.claimRecap, 'claim.lossDate'),
                  )
                }
                onChange={handleDateChange(VICTIM.DATE_OF_BIRTH)}
                InputProps={props.inputProps}
                disabled={props.disableInput}
                helperText={
                  checkVictimAge(
                    formValues.dateOfBirth,
                    get(props.claimRecap, 'claim.lossDate'),
                  )
                    ? translate(messages.birthDateValidation, props)
                    : message[VICTIM.DATE_OF_BIRTH]
                }
              />
            </MuiPickersUtilsProvider>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <FormControl
            className="input input-gender"
            error={!!get(props.victimValidation, [VICTIM.GENDER])}
          >
            <InputLabel
              ref={inputLabel}
              id="simple-select-outlined-label-procedure"
              shrink={props.inputLabelProps}
            >
              {translate({ ...messages.sexe }, props)}
            </InputLabel>
            <StyledSelect
              name={VICTIM.GENDER}
              value={get(formValues, [VICTIM.GENDER], '')}
              onChange={handleChange(VICTIM.GENDER)}
              disabled={props.disableInput}
              labelWidth={230}
            >
              <MenuItem value={GENDER.MALE} key={0}>
                {GENDER.MALE}
              </MenuItem>
              <MenuItem value={GENDER.FEMALE} key={1}>
                {GENDER.FEMALE}
              </MenuItem>
            </StyledSelect>
          </FormControl>
          {!!get(props.victimValidation, [VICTIM.GENDER]) && (
            <FormHelperText className="errorSelect">
              {message[VICTIM.GENDER]}
            </FormHelperText>
          )}
        </Grid>
        <Grid container item spacing={2}>
          <Grid item xs={12}>
            <ReactInputMask
              mask="9999 999 999"
              value={formValues.telephoneNumber}
              onChange={handleChange(VICTIM.TELEPHONE_NUMBER)}
              disabled={props.disableInput}
            >
              {() => (
                <TextField
                  label={translate({ ...messages.victimTelephone }, props)}
                  className="input"
                  error={
                    !!get(props.victimValidation, [VICTIM.TELEPHONE_NUMBER])
                  }
                  helperText={message[VICTIM.TELEPHONE_NUMBER]}
                  disabled={props.disableInput}
                ></TextField>
              )}
            </ReactInputMask>
          </Grid>
          <Grid item xs={12}>
            <FormControl
              fullWidth
              error={!!get(props.victimValidation, [VICTIM.QUALITY_KEY])}
            >
              <InputLabel
                ref={inputLabel}
                id="simple-select-outlined-label-procedure"
                shrink={props.inputLabelProps}
              >
                {translate({ ...messages.victimQualityKey }, props)}
              </InputLabel>
              <Select
                fullWidth
                name={VICTIM.QUALITY_KEY}
                value={formValues.qualityKey}
                onChange={handleChange(VICTIM.QUALITY_KEY)}
                disabled={props.disableInput}
              >
                {!isEmpty(get(props.listings, 'qualityOfVictim', [])) &&
                  props.listings!.qualityOfVictim.map(classItem => (
                    <MenuItem value={classItem.ItemKey} key={classItem.ItemKey}>
                      {classItem.ItemDescription}
                    </MenuItem>
                  ))}
              </Select>
              {!!get(props.victimValidation, [VICTIM.QUALITY_KEY]) && (
                <FormHelperText className="errorSelect">
                  {message[VICTIM.QUALITY_KEY]}
                </FormHelperText>
              )}
            </FormControl>
          </Grid>
          {displayVehiclePassenger(formValues) && (
            <Grid item xs={12}>
              <FormControl
                className="input"
                error={
                  !!get(props.victimValidation, [VICTIM.VEHICLE_PASSENGER_ID])
                }
              >
                <InputLabel
                  ref={inputLabel}
                  id="simple-select-outlined-label-procedure"
                >
                  {translate({ ...messages.vehiclePassenger }, props)}
                </InputLabel>
                <Select
                  name={VICTIM.VEHICLE_PASSENGER_ID}
                  value={get(formValues, [VICTIM.VEHICLE_PASSENGER_ID], '')}
                  onChange={handleChange(VICTIM.VEHICLE_PASSENGER_ID)}
                >
                  {get(props.listings, 'vehiclePassenger', []).map(
                    (classItem: any) => (
                      <MenuItem value={classItem.id} key={classItem.id}>
                        {classItem.title}
                      </MenuItem>
                    ),
                  )}
                </Select>
                {!!get(props.victimValidation, [
                  VICTIM.VEHICLE_PASSENGER_ID,
                ]) && (
                  <FormHelperText className="errorSelect">
                    {message[VICTIM.VEHICLE_PASSENGER_ID]}
                  </FormHelperText>
                )}
              </FormControl>
            </Grid>
          )}
          <Grid item xs={12}>
            <FormControl
              fullWidth
              error={
                !!get(props.victimValidation, [VICTIM.CLASS_KEY]) ||
                checkClassVictim(
                  get(formValues, [VICTIM.DATE_OF_BIRTH]),
                  get(props.claimRecap, 'claim.lossDate'),
                  get(formValues, [VICTIM.CLASS_KEY]),
                )
              }
            >
              <InputLabel
                ref={inputLabel}
                id="simple-select-outlined-label-class"
                shrink={props.inputLabelProps}
              >
                {translate({ ...messages.class }, props)}
              </InputLabel>
              <Select
                fullWidth
                name={VICTIM.CLASS_KEY}
                value={formValues.classKey}
                onChange={handleChange(VICTIM.CLASS_KEY)}
                disabled={props.disableInput}
              >
                {!isEmpty(get(props.listings, 'classVictim', [])) &&
                  props.listings!.classVictim.map(classItem => (
                    <MenuItem value={classItem.ItemKey} key={classItem.ItemKey}>
                      {classItem.ItemDescription}
                    </MenuItem>
                  ))}
              </Select>
              {(!!get(props.victimValidation, [VICTIM.CLASS_KEY]) ||
                checkClassVictim(
                  get(formValues, [VICTIM.DATE_OF_BIRTH]),
                  get(props.claimRecap, 'claim.lossDate'),
                  get(formValues, [VICTIM.CLASS_KEY]),
                )) && (
                <FormHelperText className="errorSelect">
                  {checkClassVictim(
                    get(formValues, [VICTIM.DATE_OF_BIRTH]),
                    get(props.claimRecap, 'claim.lossDate'),
                    get(formValues, [VICTIM.CLASS_KEY]),
                  )
                    ? translate(messages.classKeyValidation, props)
                    : message[VICTIM.CLASS_KEY]}
                </FormHelperText>
              )}
            </FormControl>
          </Grid>
        </Grid>
        <Grid container item spacing={2}>
          <Grid item xs={12}>
            <FormControl
              fullWidth
              error={!!get(props.victimValidation, [VICTIM.PROCEDURE_ID])}
            >
              <InputLabel
                ref={inputLabel}
                id="simple-select-outlined-label-procedure"
                shrink={props.inputLabelProps}
              >
                {translate({ ...messages.typeProcedure }, props)}
              </InputLabel>
              <Select
                fullWidth
                name={VICTIM.PROCEDURE_ID}
                value={formValues.procedureId}
                onChange={handleChange(VICTIM.PROCEDURE_ID)}
                disabled={props.disableInput}
                labelWidth={230}
              >
                {!isEmpty(get(props.listings, 'procedures', [])) &&
                  filterVisibleOnly(props.listings!.procedures).map(
                    procedure => (
                      <MenuItem value={procedure.id} key={procedure.id}>
                        {procedure.title}
                      </MenuItem>
                    ),
                  )}
              </Select>
              {!!get(props.victimValidation, [VICTIM.PROCEDURE_ID]) && (
                <FormHelperText className="errorSelect">
                  {message[VICTIM.PROCEDURE_ID]}
                </FormHelperText>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <AutoComplete
              options={get(props.listings, 'Profession', [])}
              getOptionLabel={(option: any) =>
                `${option?.ItemDescription ? option?.ItemDescription : ''}`
              }
              value={
                get(props.listings, 'Profession', []).find(
                  (item: any) =>
                    item.ItemKey === get(formValues, VICTIM.PROFESSION_TYPE),
                ) || {}
              }
              onChange={handleChange(VICTIM.PROFESSION_TYPE)}
              renderInput={(params: any) => (
                <TextField
                  {...params}
                  label={translate(messages.professionType, props)}
                  error={
                    !!get(props.victimValidation, [VICTIM.PROFESSION_TYPE])
                  }
                  helperText={message[VICTIM.PROFESSION_TYPE]}
                />
              )}
            />
          </Grid>
          {isOtherProfession(
            get(props.listings, 'Profession', []),
            get(formValues, VICTIM.PROFESSION_TYPE),
          ) && (
            <Grid item xs={12}>
              <TextField
                fullWidth
                label={translate({ ...messages.profession }, props)}
                InputProps={props.inputProps}
                disabled={props.disableInput}
                name={VICTIM.PROFESSION}
                value={formValues.profession}
                onChange={handleChange(VICTIM.PROFESSION)}
                error={!!get(props.victimValidation, [VICTIM.PROFESSION])}
                InputLabelProps={{ shrink: props.inputLabelProps }}
                helperText={message[VICTIM.PROFESSION]}
              />
            </Grid>
          )}
          <Grid item xs={12}>
            <FormControl
              fullWidth
              error={!!get(props.victimValidation, [VICTIM.WORK_ACCIDENT_ID])}
            >
              <InputLabel
                ref={inputLabel}
                id="simple-select-outlined-label-work-accident"
                shrink={props.inputLabelProps}
              >
                {translate({ ...messages.workAccident }, props)}
              </InputLabel>
              <Select
                fullWidth
                name={VICTIM.WORK_ACCIDENT_ID}
                value={formValues.workAccidentId}
                onChange={handleChange(VICTIM.WORK_ACCIDENT_ID)}
                disabled={props.disableInput}
                labelWidth={140}
              >
                {!isEmpty(get(props.listings, 'workAccidents', [])) &&
                  props.listings!.workAccidents.map(type => (
                    <MenuItem value={type.id} key={type.id}>
                      {type.title}
                    </MenuItem>
                  ))}
              </Select>
              {!!get(props.victimValidation, [VICTIM.WORK_ACCIDENT_ID]) && (
                <FormHelperText className="errorSelect">
                  {message[VICTIM.WORK_ACCIDENT_ID]}
                </FormHelperText>
              )}
            </FormControl>
          </Grid>
          {get(formValues, [VICTIM.INJURY_POST_KEY], '') !== '' &&
            !INJURY_POST.DECEASED.includes(
              get(formValues, [VICTIM.INJURY_POST_KEY], ''),
            ) && (
              <>
                <Grid item xs={12}>
                  <FormControl
                    fullWidth
                    error={
                      !!get(props.victimValidation, [VICTIM.ITT_AVAILABILITY])
                    }
                  >
                    <InputLabel
                      ref={inputLabel}
                      id="simple-select-outlined-label-procedure"
                      shrink={props.inputLabelProps}
                    >
                      {translate({ ...messages.availabilityItt }, props)}
                    </InputLabel>
                    <Select
                      fullWidth
                      name={VICTIM.ITT_AVAILABILITY}
                      value={get(formValues, [VICTIM.ITT_AVAILABILITY], null)}
                      onChange={handleChange(VICTIM.ITT_AVAILABILITY)}
                    >
                      <MenuItem
                        value={VICTIM_ITT_AVAILABILITY.AVAILABLE}
                        key={uniqueId()}
                      >
                        {translate({ ...messages.available }, props)}
                      </MenuItem>
                      <MenuItem
                        value={VICTIM_ITT_AVAILABILITY.NOT_AVAILABLE}
                        key={uniqueId()}
                      >
                        {translate({ ...messages.notAvailable }, props)}
                      </MenuItem>
                    </Select>

                    {!!get(props.victimValidation, [
                      VICTIM.ITT_AVAILABILITY,
                    ]) && (
                      <FormHelperText className="errorSelect">
                        {message[VICTIM.ITT_AVAILABILITY]}
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>
                {(get(formValues, [VICTIM.ITT_AVAILABILITY]) ===
                  VICTIM_ITT_AVAILABILITY.AVAILABLE ||
                  (!isNil(get(formValues, [VICTIM.ITT], null)) &&
                    get(formValues, [VICTIM.ITT]) !== '')) && (
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      type="number"
                      label={translate({ ...messages.ITT }, props)}
                      InputProps={{
                        ...props.inputProps,
                        inputProps: { min: 0 },
                      }}
                      disabled={props.disableInput}
                      name={VICTIM.ITT}
                      value={parseInt((formValues.itt as unknown) as string)}
                      onChange={handleChange(VICTIM.ITT)}
                      error={!!get(props.victimValidation, [VICTIM.ITT])}
                      helperText={message[VICTIM.ITT]}
                      InputLabelProps={{
                        shrink: props.inputLabelProps,
                      }}
                    />
                  </Grid>
                )}
              </>
            )}
        </Grid>
        <Grid container item spacing={2}>
          <Grid item xs={12}>
            <FormControl
              fullWidth
              error={!!get(props.victimValidation, [VICTIM.OPPOSITION])}
            >
              <InputLabel
                ref={inputLabel}
                id="simple-select-outlined-label-work-accident"
                shrink={props.inputLabelProps}
              >
                {translate({ ...messages.victimOpposition }, props)}
              </InputLabel>
              <Select
                fullWidth
                name={VICTIM.OPPOSITION}
                value={formValues.opposition}
                onChange={handleChange(VICTIM.OPPOSITION)}
                disabled={props.disableInput}
                labelWidth={140}
              >
                <MenuItem value={0} key={uniqueId('oppos_')}>
                  {translate({ ...messages.claimDeclarationNo }, props)}
                </MenuItem>
                <MenuItem value={1} key={uniqueId()}>
                  {translate({ ...messages.claimDeclarationYes }, props)}
                </MenuItem>
              </Select>
              {!!get(props.victimValidation, [VICTIM.OPPOSITION]) && (
                <FormHelperText className="errorSelect">
                  {message[VICTIM.OPPOSITION]}
                </FormHelperText>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <Autocomplete
              id="standard-basic-2"
              options={getMoroccanCities(get(props.listings, 'villes', []))}
              getOptionLabel={city => city.ItemDescription}
              onChange={handleCityChange(VICTIM.CITY)}
              autoSelect={true}
              value={getCity(get(props.listings, 'villes', []), '')}
              filterOptions={filterOptions}
              renderInput={params => (
                <TextField
                  {...params}
                  name={VICTIM.CITY}
                  label={translate({ ...messages.victimCity }, props)}
                  error={!!get(props.victimValidation, [VICTIM.CITY])}
                  helperText={message[VICTIM.CITY]}
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label={translate({ ...messages.adress }, props)}
              InputProps={props.inputProps}
              disabled={props.disableInput}
              name={VICTIM.ADDRESS}
              value={formValues.address}
              onChange={handleChange(VICTIM.ADDRESS)}
              InputLabelProps={{ shrink: props.inputLabelProps }}
              error={!!get(props.victimValidation, [VICTIM.ADDRESS])}
              helperText={message[VICTIM.ADDRESS]}
            />
          </Grid>
        </Grid>
        {INJURY_POST.DECEASED.includes(
          get(formValues, [VICTIM.INJURY_POST_KEY], ''),
        ) && (
          <>
            <Grid item xs={12}>
              <TextField
                type="number"
                label={translate({ ...messages.numberOfPartners }, props)}
                className="input-2-3"
                fullWidth
                error={!!get(props.victimValidation, [VICTIM.NUMBER_OF_SPOUSE])}
                disabled={
                  props.disableInput ||
                  get(formValues, [VICTIM.CLASS_KEY]) === MINOR_VALUE
                }
                name={VICTIM.NUMBER_OF_SPOUSE}
                value={get(formValues, [VICTIM.NUMBER_OF_SPOUSE])}
                onChange={handleChange(VICTIM.NUMBER_OF_SPOUSE)}
                InputLabelProps={{
                  shrink: props.inputLabelProps,
                }}
                InputProps={{
                  inputProps:
                    get(formValues, [VICTIM.GENDER], '') === GENDER.FEMALE
                      ? {
                          ...props.inputProps,
                          max: 1,
                          min: 0,
                        }
                      : props.inputProps,
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label={translate({ ...messages.numberOfChildren }, props)}
                type="number"
                fullWidth
                className="input-4"
                InputProps={props.inputProps}
                disabled={
                  props.disableInput ||
                  get(formValues, [VICTIM.CLASS_KEY]) === MINOR_VALUE
                }
                name={VICTIM.NUMBER_OF_CHILDREN}
                value={get(formValues, [VICTIM.NUMBER_OF_CHILDREN])}
                onChange={handleChange(VICTIM.NUMBER_OF_CHILDREN)}
                InputLabelProps={{
                  shrink: props.inputLabelProps,
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                type="number"
                fullWidth
                label={translate({ ...messages.numberOfDependents }, props)}
                className="input-4-1"
                InputProps={props.inputProps}
                disabled={
                  props.disableInput ||
                  get(formValues, [VICTIM.CLASS_KEY]) === MINOR_VALUE
                }
                name={VICTIM.NUMBER_OF_DEPENDENTS}
                value={get(formValues, [VICTIM.NUMBER_OF_DEPENDENTS])}
                onChange={handleChange(VICTIM.NUMBER_OF_DEPENDENTS)}
                InputLabelProps={{
                  shrink: props.inputLabelProps,
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label={translate({ ...messages.annualOfIncome }, props)}
                className="input-4-1"
                fullWidth
                InputProps={props.inputProps}
                disabled={props.disableInput}
                name={VICTIM.ANNUAL_INCOME}
                value={get(formValues, [VICTIM.ANNUAL_INCOME])}
                onChange={handleChange(VICTIM.ANNUAL_INCOME)}
                InputLabelProps={{
                  shrink: props.inputLabelProps,
                }}
              />
            </Grid>
          </>
        )}
        {INJURY_POST.DECEASED.includes(
          get(formValues, [VICTIM.INJURY_POST_KEY], ''),
        ) && (
          <div className="deceaseBlock">
            <Typography className="text deceased-title">
              <PrimaryButton
                data-testid="add_beneficiary_btn"
                className="add-beneficiary-btn"
                onClick={() => openFormBeneficiary()}
                title={translate({ ...messages.addBeneficiaryBtn }, props)}
              />
            </Typography>
          </div>
        )}
        {formValues.beneficiaries &&
          formValues.beneficiaries.map(
            (beneficiary: BeneficiaryType, beneficiary_index: number) => {
              return (
                <div key={beneficiary_index} className="beneficiary">
                  <BeneficiaryAccordion
                    listing={props.listings}
                    beneficiary={
                      ({
                        ...beneficiary,
                      } as unknown) as BeneficiaryType
                    }
                    index={beneficiary_index}
                    isDrawer={false}
                    inputProps={props.inputProps}
                    disableInput
                    inputLabelProps={props.inputLabelProps}
                    editButtonTitle={undefined}
                    handleBeneficiaryChange={handleBeneficiaryChange(
                      beneficiary_index,
                    )}
                    isDrawerAdd={props.isDrawerAdd}
                    victim={formValues}
                    lossDate={get(props.claimRecap, 'claim.lossDate')}
                  />
                </div>
              );
            },
          )}

        {openBeneficiaryForm && (
          <BeneficiaryAccordion
            listing={props.listings}
            isOpeningManager={false}
            isDrawer={false}
            beneficiary={
              {
                [BENEFICIARY.DEPENDENT_INDICATOR]: true,
              } as any
            }
            inputProps={props.inputProps}
            disableInput={props.disableInput}
            inputLabelProps={props.inputLabelProps}
            handleBeneficiaryChange={saveBeneficiary}
            handleCancel={closeFormBeneficiary}
            victim={formValues}
            isDrawerAdd={props.isDrawerAdd}
            lossDate={get(props.claimRecap, 'claim.lossDate')}
          />
        )}
      </ContentWrapper>
    </SahamAccordion>
  );
};
export default injectIntl(VictimFormComponent);
